export default __webpack_public_path__ + "static/former-organiske1-ce276ba0e09b7af473cbedb24a24a0d9.png";